/**
 * Realtime client (docs/BUILD-PHASES.md Phase 4/11 gaps). One shared
 * connection, authenticated with the same access token every REST call
 * uses, joined to the active shop's room via `shop:watch`. `socket.io-client`
 * was a listed dependency with zero code against it until now.
 */
import { io, type Socket } from 'socket.io-client';

let socket: Socket | null = null;

/** Creates the shared connection if needed and (re)points it at `shopId`. Safe to call on every shop switch. */
export function connectSocket(accessToken: string, shopId: string | null): Socket {
  if (!socket) {
    socket = io('/', { path: '/socket.io', auth: { token: accessToken }, autoConnect: true });
  } else if (socket.auth && (socket.auth as { token?: string }).token !== accessToken) {
    socket.auth = { token: accessToken };
    socket.connect();
  }
  if (shopId) socket.emit('shop:watch', shopId);
  return socket;
}

export function disconnectSocket(): void {
  socket?.disconnect();
  socket = null;
}

export function getSocket(): Socket | null {
  return socket;
}
